export interface PickFileOptions {
  accept?: string;
}

export function pickFile({ accept = '.xlsx,.xls,.csv' }: PickFileOptions = {}): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = () => resolve(input.files?.[0] ?? null);
    input.click();
  });
}
